var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loader)?_c('div',[_c('Loader')],1):_vm._e(),(!_vm.loader)?_c('div',{staticClass:"w-full",attrs:{"id":"scatter-chart"}}):_vm._e(),_c('highcharts',{attrs:{"options":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }